import React from 'react';
import { forNamespace } from '@trello/i18n';
import classNames from 'classnames';
import styles from './BoardTemplateBadge.less';

const format = forNamespace('board template badge');

const toCamelCase = (str: string) =>
  str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());

type BadgeAppearances = 'default' | 'transparent' | 'transparent-dark';
interface BoardTemplateBadgeProps {
  dangerous_className?: string;
  /** The visible appearance of a template badge.
   *
   * @default 'default'
   */
  appearance?: BadgeAppearances;
}

export const BoardTemplateBadge: React.FunctionComponent<BoardTemplateBadgeProps> = ({
  dangerous_className,
  appearance = 'default',
}) => {
  return (
    <div
      className={classNames(
        styles.boardTemplateBadge,
        styles[toCamelCase(appearance)],
        dangerous_className,
      )}
      title={format('templates are read-only boards for others to copy')}
    >
      {format('template')}
    </div>
  );
};
